import { render, staticRenderFns } from "./FormSpecifications.vue?vue&type=template&id=b6d28048&"
import script from "./FormSpecifications.vue?vue&type=script&lang=js&"
export * from "./FormSpecifications.vue?vue&type=script&lang=js&"
import style0 from "./FormSpecifications.vue?vue&type=style&index=0&id=b6d28048&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports